import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  DataService as CoreDataService,
  Query,
  QueryColumn,
  QueryColumnSortOrder,
  QueryObjectsModel,
} from '@barthauer/abc/core/data';
import { Project } from '@barthauer/custom/xmt-models';
import { finalize, Subscription } from 'rxjs';
import { DataService, ObjectKeys } from '../../../services/data.service';
import { CompaniesService } from '../companies.service';

@Component({
  selector: 'project-card',
  templateUrl: './project-card.component.html',
  styleUrls: ['./project-card.component.scss'],
  standalone: false,
})
export class ProjectCardComponent {
  @Output() selectLastProjectUpdated = new EventEmitter<Project>();

  public projectList: Project[] = [];

  private subscriptions: Subscription[] = [];

  constructor(
    private coreDataService: CoreDataService,
    private companiesService: CompaniesService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    public dataService: DataService,
  ) {}

  public ngOnInit(): void {
    const sub = this.prepareProjectsByProjectPerson()
      .pipe(
        finalize(() => {
          this.cdr.markForCheck();
        }),
      )
      .subscribe({
        next: (result) => {
          if (Array.isArray(result) && result.length > 0) {
            this.projectList = result;
          } else {
            this.projectList = [];
          }
        },
        error: (err) => {
          console.error(err);
          this.projectList = [];
        },
      });

    this.subscriptions.push(sub);
  }
  get locale(): string {
    const lang = sessionStorage.getItem('currentUserLanguage');
    return lang === 'de' ? 'de-DE' : 'en-US';
  }
 public prepareProjectsByProjectPerson() {
    const profileId = sessionStorage.getItem('profileId');
    const opath = `IdRefPerson='${profileId}'`;

    const projectPerson: Query = new Query();
    projectPerson.Columns = this.companiesService.projectPersonColumns
    projectPerson.ObjectType = ObjectKeys.PROJECT_PERSON;
    projectPerson.OPath = opath;

 

  const queryObjectModel = new QueryObjectsModel();
    queryObjectModel.ObjectQueries = [projectPerson];

    return this.coreDataService.executeReadObjectsQuery(queryObjectModel);
  }

  public selectProject(project: Project) {
    this.router.navigate(['dashboard']);
    this.companiesService.selectedProjectData(project);
    this.selectLastProjectUpdated.emit(project);
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
